var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.05977 0.759766C2.44977 0.759766 1.86475 1.00209 1.43342 1.43342C1.00209 1.86475 0.759766 2.44977 0.759766 3.05977L0.759766 12.2598C0.759766 12.8698 1.00209 13.4548 1.43342 13.8861C1.86475 14.3174 2.44977 14.5598 3.05977 14.5598H5.93477C6.1133 14.5598 6.28938 14.6013 6.44906 14.6812C6.60875 14.761 6.74765 14.8769 6.85477 15.0198L9.03977 17.9327C9.14688 18.0755 9.28579 18.1915 9.44547 18.2713C9.60515 18.3512 9.78123 18.3927 9.95977 18.3927C10.1383 18.3927 10.3144 18.3512 10.4741 18.2713C10.6337 18.1915 10.7726 18.0755 10.8798 17.9327L13.0648 15.0198C13.1719 14.8769 13.3108 14.761 13.4705 14.6812C13.6302 14.6013 13.8062 14.5598 13.9848 14.5598H16.8598C17.4698 14.5598 18.0548 14.3174 18.4861 13.8861C18.9174 13.4548 19.1598 12.8698 19.1598 12.2598V3.05977C19.1598 2.44977 18.9174 1.86475 18.4861 1.43342C18.0548 1.00209 17.4698 0.759766 16.8598 0.759766L3.05977 0.759766Z",
    fill: "white",
    fillOpacity: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.1c9c5c584ec3565663fb80db0eb7c934.svg";
export { ForwardRef as ReactComponent };